import styled from 'styled-components';
import { REFERRAL_CONTENT_MAX_WIDTH_PX } from './layout';
import { FONT_FAMILY_SANS } from './typography';

export const ReferralDesktopContainer = styled.div`
  width: 100%;
  max-width: ${REFERRAL_CONTENT_MAX_WIDTH_PX}px;
  margin-inline: auto;
  box-sizing: border-box;
`;

export const ReferralPageRoot = styled.div`
  font-family: ${FONT_FAMILY_SANS};
  color: #131212;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

export const Loader = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
